

(function () {
  'use strict';

  var productCache = {};

  var SIZE_MAP = {
    'X-Small': 'XS', 'Small': 'S', 'Medium': 'M',
    'Large': 'L', 'X-Large': 'XL', '2XL': '2XL', 'XX-Large': '2XL', '3XL': '3XL'
  };

  function init() {
    document.querySelectorAll('.wc-quick-add').forEach(function (container) {
      
      if (container.dataset.wcInitialized) return;
      container.dataset.wcInitialized = 'true';

      var btn = container.querySelector('.wc-quick-add__btn');
      var handle = container.dataset.productHandle;
      var singleVariant = container.dataset.singleVariant;

      if (!btn || !handle) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (singleVariant) {
          addToCart(container, singleVariant);
          return;
        }

        
        
        var quickSize = container.dataset.wcQuickSize;
        if (quickSize) {
          quickAddSize(container, handle, quickSize);
          return;
        }
        showSizes(container, handle);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.wc-quick-add')) {
        document.querySelectorAll('.wc-quick-add__sizes:not([hidden])').forEach(function (el) {
          el.setAttribute('hidden', '');
          el.innerHTML = '';
          var btn = el.closest('.wc-quick-add').querySelector('.wc-quick-add__btn');
          if (btn) btn.removeAttribute('hidden');
        });
      }
    });
  }

  function showSizes(container, handle) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    if (!sizesEl) return;

    var embeddedData = container.dataset.variants;
    if (embeddedData) {
      try {
        var variants = JSON.parse(embeddedData);
        renderSizeButtons(container, variants);
        return;
      } catch (e) {
        console.error('[WC Quick Add] Failed to parse embedded variants:', e);
      }
    }

    btn.textContent = '...';
    btn.setAttribute('disabled', '');

    if (productCache[handle]) {
      renderSizeButtons(container, productCache[handle].variants);
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache[handle] = data.product;
        renderSizeButtons(container, data.product.variants);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Fetch error:', err);
        btn.textContent = defaultBtnLabel(container);
        btn.removeAttribute('disabled');
      });
  }

  
  function defaultBtnLabel(container) {
    var qs = container && container.dataset.wcQuickSize;
    return qs ? '+ Quick Add ' + qs : '+ Quick Add';
  }

  
  
  function quickAddSize(container, handle, sizeAbbr) {
    var btn = container.querySelector('.wc-quick-add__btn');
    function pick(variants) {
      var match = null;
      variants.forEach(function (v) {
        if (match) return;
        var sizeName = v.option1 || v.title;
        var abbr = SIZE_MAP[sizeName] || sizeName;
        if (abbr === sizeAbbr && v.available) match = v;
      });
      if (match) {
        addToCart(container, match.id, sizeAbbr);
      } else {
        showSizes(container, handle);
      }
    }
    var embedded = container.dataset.variants;
    if (embedded) {
      try { pick(JSON.parse(embedded)); return; }
      catch (e) { console.error('[WC Quick Add] Failed to parse embedded variants:', e); }
    }
    if (productCache[handle]) { pick(productCache[handle].variants); return; }
    if (btn) { btn.textContent = '...'; btn.setAttribute('disabled', ''); }
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache[handle] = data.product;
        if (btn) { btn.textContent = defaultBtnLabel(container); btn.removeAttribute('disabled'); }
        pick(data.product.variants);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Fetch error:', err);
        if (btn) { btn.textContent = defaultBtnLabel(container); btn.removeAttribute('disabled'); }
      });
  }

  function renderSizeButtons(container, variants) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');

    btn.setAttribute('hidden', '');

    var html = '';
    variants.forEach(function (variant) {
      var sizeName = variant.option1 || variant.title;
      var abbr = SIZE_MAP[sizeName] || sizeName;
      var available = variant.available;
      html += '<button type="button" class="wc-quick-add__size-btn' +
        (!available ? ' wc-quick-add__size-btn--unavailable' : '') +
        '" data-variant-id="' + variant.id + '"' +
        (!available ? ' disabled' : '') +
        '>' + abbr + '</button>';
    });
    sizesEl.innerHTML = html;
    sizesEl.removeAttribute('hidden');

    sizesEl.querySelectorAll('.wc-quick-add__size-btn').forEach(function (sizeBtn) {
      sizeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeBtn.hasAttribute('disabled')) return;
        addToCart(container, sizeBtn.dataset.variantId, sizeBtn.textContent);
      });
    });
  }

  function addToCart(container, variantId, sizeName) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    var statusEl = container.querySelector('.wc-quick-add__status');

    if (btn) btn.setAttribute('hidden', '');
    if (sizesEl) sizesEl.setAttribute('hidden', '');
    if (statusEl) {
      statusEl.removeAttribute('hidden');
      statusEl.className = 'wc-quick-add__status wc-quick-add__status--adding';
      statusEl.textContent = 'Adding...';
    }

    var body = JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: 1 }]
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          
          showError(container, response.description || 'Error adding to cart');
          return;
        }

        if (statusEl) {
          statusEl.className = 'wc-quick-add__status wc-quick-add__status--added';
          statusEl.textContent = '\u2713 Added' + (sizeName ? ' \u2014 ' + sizeName : '');
        }

        fetchCartAndOpenDrawer();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'wc-quick-add',
            productVariantId: variantId,
            cartData: response
          });
        }

        setTimeout(function () {
          resetToDefault(container);
        }, 1500);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Cart add error:', err);
        showError(container, 'Error adding to cart');
      });
  }

  function fetchCartAndOpenDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newDrawerInner = parsed.querySelector('.drawer__inner');
        var currentDrawerInner = document.querySelector('.drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        fetch('/cart?section_id=cart-icon-bubble')
          .then(function (r) { return r.text(); })
          .then(function (bubbleHtml) {
            var parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
            var newBubble = parsedBubble.querySelector('.shopify-section');
            var currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          });

        setTimeout(function () {
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', function () { cartDrawer.close(); });
          }
          cartDrawer.classList.remove('is-empty');
          cartDrawer.open();
        }, 100);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Cart drawer update error:', err);
      });
  }

  function resetToDefault(container) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    var statusEl = container.querySelector('.wc-quick-add__status');

    if (btn) {
      btn.textContent = defaultBtnLabel(container);
      btn.removeAttribute('disabled');
      btn.removeAttribute('hidden');
    }
    if (sizesEl) {
      sizesEl.setAttribute('hidden', '');
      sizesEl.innerHTML = '';
    }
    if (statusEl) {
      statusEl.setAttribute('hidden', '');
      statusEl.textContent = '';
    }
  }

  function showError(container, message) {
    var statusEl = container.querySelector('.wc-quick-add__status');
    if (statusEl) {
      statusEl.className = 'wc-quick-add__status wc-quick-add__status--error';
      statusEl.textContent = message;
    }
    setTimeout(function () { resetToDefault(container); }, 2000);
  }

  
  var WC_SIZES = ['S', 'M', 'L', 'XL', '2XL'];
  var currentCartSize = null;

  
  function computeCartSize(cart) {
    var tally = {};
    var items = (cart && cart.items) || [];
    items.forEach(function (item) {
      (item.options_with_values || []).forEach(function (opt) {
        if (!opt || opt.name !== 'Size') return;
        var abbr = SIZE_MAP[opt.value] || opt.value;
        if (WC_SIZES.indexOf(abbr) === -1) return;
        tally[abbr] = (tally[abbr] || 0) + (item.quantity || 0);
      });
    });
    var best = null, bestN = 0;
    WC_SIZES.forEach(function (s) {
      if ((tally[s] || 0) > bestN) { bestN = tally[s]; best = s; }
    });
    return best;
  }

  
  function effectiveSize() {
    var fromFilter = null;
    try { fromFilter = new URLSearchParams(location.search).get('wc-size'); }
    catch (e) {}
    if (fromFilter && WC_SIZES.indexOf(fromFilter) > -1) return fromFilter;
    return currentCartSize;
  }

  

  function applyTreatment() {
    var size = effectiveSize();
    document.querySelectorAll('.wc-quick-add').forEach(function (qa) {

      
      if (!qa.dataset.productHandle) return;
      var ok = false;
      if (size) {
        var card = qa.closest('[data-wc-sizes]');
        var sizes = card ? (' ' + (card.getAttribute('data-wc-sizes') || '') + ' ') : '';
        if (sizes.indexOf(' ' + size + ' ') > -1) ok = true;
      }
      if (ok) {
        qa.setAttribute('data-wc-quick-size', size);
      } else {
        qa.removeAttribute('data-wc-quick-size');
      }
      var btn = qa.querySelector('.wc-quick-add__btn');
      if (btn && !btn.hasAttribute('hidden') && btn.textContent !== '...') {
        btn.textContent = defaultBtnLabel(qa);
      }
    });
  }

  function fetchCartSize() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        currentCartSize = computeCartSize(cart);
        applyTreatment();
      })
      .catch(function () { applyTreatment(); });
  }

  function start() {
    init();
    applyTreatment();  
    fetchCartSize();   
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartSize);
  }
  document.addEventListener('wc:quickadd-refresh', applyTreatment);

  
  
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetchCartSize();
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        var hasNewQuickAdd = false;
        mutations[i].addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.classList.contains('wc-quick-add') || node.querySelector('.wc-quick-add'))) {
            hasNewQuickAdd = true;
          }
        });
        if (hasNewQuickAdd) {
          init();
          applyTreatment();
          break;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
